import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import LeftArrowIcon from '../../components/icons/LeftArrowIcon';
import RightArrowIcon from '../../components/icons/RightArrowIcon';
import PreFooter from '../../components/prefooter';
import modernDataStackTechnicalRoadmapImg from '../../images/whitepapers/modern-data-stack-technical-roadmap.jpg';
import modernDataStackImg from '../../images/whitepapers/modern-data-stack.jpg';
import DownloadForm from './DownloadForm';
import {
  WhitepaperContainer,
  LeftColumn,
  RightColumn,
  Title,
  Text,
  TextBlue,
  TextBlue2,
  WhitepapersCarousel,
  RightButton,
  LeftButton,
} from './style';

const whitepaperNames = [
  'modern-data-stack',
  'modern-data-stack-technical-roadmap',
];

const Whitepapers = () => {
  const { t } = useTranslation();

  const location = useLocation();
  const params = useParams<{ whitepaper?: string }>();
  const [carousel, setCarouselRef] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!carousel) return;
    const param = params.whitepaper || location.hash.slice(1);
    if (!param) return;
    const numberParam = Number(param);
    let whitepaperIndex =
      numberParam &&
      isFinite(numberParam) &&
      0 < numberParam &&
      numberParam <= whitepaperNames.length
        ? numberParam
        : whitepaperNames.findIndex((name) => name === param) + 1;
    if (!whitepaperIndex) return;
    carousel.scroll({
      behavior: 'smooth',
      left: carousel.clientWidth * (whitepaperNames.length - whitepaperIndex),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carousel, params.whitepaper, location.hash]);

  return (
    <>
      <Helmet>
        <title>Mutt Data | Whitepapers</title>
        <meta property="og:title" content="Mutt Data | Whitepapers" />
        <meta
          name="description"
          content="Mutt Data is a technology company that helps you develop custom data products using Machine Learning, Data Science and Big Data to boost your business."
        />
        <meta
          property="og:description"
          content="Mutt Data is a technology company that helps you develop custom data products using Machine Learning, Data Science and Big Data to boost your business."
        />
        <meta
          property="og:image"
          content="https://muttdata.ai/email/logo.png"
        />
        <meta property="og:url" content="https://muttdata.ai" />
        <meta
          name="keywords"
          content="machine learning machine-learning ML data science data-science ciencia de datos big data cloud computing AWS Amazon Web Services data engineering data products productos de datos data systems"
        />
      </Helmet>
      <WhitepapersCarousel ref={setCarouselRef}>
        <WhitepaperContainer id="modern-data-stack-technical-roadmap">
          <div className="container">
            <LeftColumn>
              <Title
                className="animate__animated animate__fadeIn animate__faster animate__delay-1s"
                dangerouslySetInnerHTML={{
                  __html: t('Whitepaper2Title'),
                }}
              />
              <Text
                className="animate__animated animate__fadeIn animate__faster animate__delay-2s"
                dangerouslySetInnerHTML={{
                  __html: t('Whitepaper2Text1'),
                }}
              />
              <TextBlue
                className="animate__animated animate__fadeIn animate__faster animate__delay-3s"
                dangerouslySetInnerHTML={{
                  __html: t('Whitepaper2TextBlue1'),
                }}
              />
              <Text
                className="animate__animated animate__fadeIn animate__faster animate__delay-4s"
                dangerouslySetInnerHTML={{
                  __html: t('Whitepaper2Text2'),
                }}
              />
              <TextBlue2
                className="animate__animated animate__fadeIn animate__faster animate__delay-5s"
                dangerouslySetInnerHTML={{
                  __html: t('Whitepaper2TextBlue2'),
                }}
              />
            </LeftColumn>
            <RightColumn className="animate__animated animate__fadeIn animate__faster animate__delay-1s">
              <img
                src={modernDataStackTechnicalRoadmapImg}
                alt="Modern Data Stack Technical Roadmap"
                width={400}
                height={490}
              />
              <DownloadForm whitepaper="modern-data-stack-technical-roadmap" />
            </RightColumn>
            <RightButton
              className="animate__animated animate__fadeIn animate__faster animate__delay-2s"
              to="/whitepapers/modern-data-stack"
            >
              <RightArrowIcon />
            </RightButton>
          </div>
        </WhitepaperContainer>
        <WhitepaperContainer id="modern-data-stack">
          <div className="container">
            <LeftButton
              className="animate__animated animate__fadeIn animate__faster animate__delay-2s"
              to="/whitepapers/modern-data-stack-technical-roadmap"
            >
              <LeftArrowIcon />
            </LeftButton>
            <LeftColumn>
              <Title
                className="animate__animated animate__fadeIn animate__faster animate__delay-1s"
                dangerouslySetInnerHTML={{
                  __html: t('Whitepaper1Title'),
                }}
              />
              <Text
                className="animate__animated animate__fadeIn animate__faster animate__delay-2s"
                dangerouslySetInnerHTML={{
                  __html: t('Whitepaper1Text1'),
                }}
              />
              <TextBlue
                className="animate__animated animate__fadeIn animate__faster animate__delay-3s"
                dangerouslySetInnerHTML={{
                  __html: t('Whitepaper1TextBlue1'),
                }}
              />
              <Text
                className="animate__animated animate__fadeIn animate__faster animate__delay-4s"
                dangerouslySetInnerHTML={{
                  __html: t('Whitepaper1Text2'),
                }}
              />
              <TextBlue2
                className="animate__animated animate__fadeIn animate__faster animate__delay-5s"
                dangerouslySetInnerHTML={{
                  __html: t('Whitepaper1TextBlue2'),
                }}
              />
            </LeftColumn>
            <RightColumn className="animate__animated animate__fadeIn animate__faster animate__delay-1s">
              <img
                src={modernDataStackImg}
                alt="Modern Data Stack"
                width={400}
                height={490}
              />
              <DownloadForm whitepaper="modern-data-stack" />
            </RightColumn>
          </div>
        </WhitepaperContainer>
      </WhitepapersCarousel>
      <PreFooter
        title={t('CompanyPrefooterTitle')}
        text={t('CompanyPrefooterText')}
        btnText={t('CompanyPrefooterButton')}
      />
    </>
  );
};

export default Whitepapers;
